import { useMemo } from 'react';
import { useAppStore } from '@indipia/shared';

/** 공종 코드 → 공종명 매핑 (공통코드 ZEU_WORK_TYPE). */
export function useWorkTypeName(): Map<string, string> {
  const codes = useAppStore((s) => s.codes);
  return useMemo(() => {
    const m = new Map<string, string>();
    for (const c of codes) if (c.codeGroupCode === 'ZEU_WORK_TYPE') m.set(c.codeValue, c.codeName);
    return m;
  }, [codes]);
}
